/**
 * Bulk-shipment one-click print document configuration.
 *
 * Keep in sync with the generated shape in
 * `redo/backend/db/schema/src/team/OutboundLabelSettings.ts`.
 */
export const BulkShipmentOneClickPrintDocument = ["pickList", "label"] as const;
export type BulkShipmentOneClickPrintDocument =
  (typeof BulkShipmentOneClickPrintDocument)[number];

export interface BulkShipmentOneClickPrintDocumentSetting {
  document: BulkShipmentOneClickPrintDocument;
  enabled: boolean;
}

export const DefaultBulkShipmentOneClickPrintDocuments: BulkShipmentOneClickPrintDocumentSetting[] =
  [
    { document: "pickList", enabled: true },
    { document: "label", enabled: true },
  ];

export const DefaultOneClickPrintBatchSize = 30;
export const BulkOneClickPrintBatchLimit = 25;
export const BulkOneClickPrintOrderLimit = 1500;
export const MaxBulkOneClickPrintOrders = 9000;
